<template>
  <vs-popup
    title="Fiyat Güncelle"
    button-cancel="border"
    :active.sync="isActiveLocal"
    @close="clearFields"
    @cancel="clearFields"
  >
    <div id="loading-stock-price-update" class="vs-con-loading__container">
      <b-row class="mb-1">
        <b-col cols="12">
          <strong>{{ stockName }}</strong>
        </b-col>
        <b-col cols="12" class="mb-1 mt-1">
          <strong>Stok Kodu:</strong> {{ stockCode }} - <strong>Barkod:</strong> {{ stockBarcode }}
        </b-col>
      </b-row>

      <b-row class="mb-1">
        <b-col
          v-for="marketplace in marketplaces"
          :key="marketplace.name"
          cols="12"
          md="auto"
          class="mb-3 mt-3"
        >
          <vs-button
            size="small"
            :color="activeMarketplace == marketplace.name ? 'primary' : 'success'"
            type="gradient"
            @click="pazaryeriDetay(marketplace.name)"
          >
            {{ marketplace.name }}
          </vs-button>
        </b-col>
      </b-row>

      <div v-if="marketplaceInformation != ''" class="text-danger mb-1">
        {{ marketplaceInformation }}
      </div>

      <div v-if="activeMarketplace != ''">
        <b-row align-v="center" class="mb-1">
          <b-col cols="4">Listeleme Fiyatı</b-col>
          <b-col cols="8">
            <vs-input v-model="stockDetailSalePrice" />
          </b-col>
        </b-row>
        <b-row align-v="center" class="mb-1">
          <b-col cols="4">Satış Fiyatı</b-col>
          <b-col cols="8">
            <vs-input v-model="stockDetailCurrentPrice" />
          </b-col>
        </b-row>
        <vs-row vs-justify="flex-end">
          <vs-button
            id="button-with-loading-price-update"
            class="vs-con-loading__container"
            color="warning"
            type="gradient"
            style="border-radius: 5px"
            :disabled="!isPriceChanged"
            @click="activePromptStockUpdate = true"
          >
            Fiyat Güncelle
          </vs-button>
        </vs-row>
      </div>
    </div>

    <vs-prompt
      color="warning"
      title="Ürün fiyatı pazaryerinden güncellenecek. Emin misiniz?"
      acceptText="Güncelle"
      cancelText="Vazgeç"
      :active.sync="activePromptStockUpdate"
      @accept="priceUpdate"
    >
    </vs-prompt>
  </vs-popup>
</template>

<script>
import state from "../../store/state";
import Store from "../../store/store";

export default {
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      activeMarketplace: "",
      activePromptStockUpdate: false,
      marketplaces: [],
      marketplaceInformation: "",
      stockName: "",
      stockBarcode: "",
      stockCode: "",
      stockDetailSalePrice: "",
      stockDetailCurrentPrice: "",
      originalDetailSalePrice: "",
      originalDetailCurrentPrice: "",
      alan9Ad: false,
    };
  },
  computed: {
    isPriceChanged() {
      return (
        this.stockDetailSalePrice !== this.originalDetailSalePrice ||
        this.stockDetailCurrentPrice !== this.originalDetailCurrentPrice
      );
    },
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closePriceUpdatePopup");
        }
      },
    },
  },
  watch: {
    isActive(val) {
      if (val) {
        this.prepareModal();
      }
    },
  },
  methods: {
    prepareModal() {
      this.clearDetailFields();
      this.marketplaces = [];

      this.stockName = this.data.StokAdi;
      this.stockBarcode = this.data.Barkod;
      this.stockCode = this.data.stokKodu;

      this.pazaryeriDetay();
    },
    setMarketplaces(pazaryeriXml) {
      const marketplaces = [];
      if (pazaryeriXml) {
        const regex = /<program>(.*?)<\/program>/g;
        let match;
        while ((match = regex.exec(pazaryeriXml)) !== null) {
          marketplaces.push({ name: match[1] });
        }
      }
      this.marketplaces = marketplaces;
    },
    clearFields() {
      this.clearDetailFields();
      this.stockName = "";
      this.stockBarcode = "";
      this.stockCode = "";
      this.marketplaces = [];
    },
    clearDetailFields() {
      this.activeMarketplace = "";
      this.marketplaceInformation = "";
      this.stockDetailSalePrice = "";
      this.stockDetailCurrentPrice = "";
      this.originalDetailSalePrice = "";
      this.originalDetailCurrentPrice = "";
      this.alan9Ad = false;
    },
    pazaryeriDetay(pazaryeri) {
      this.activeMarketplace = pazaryeri;
      this.marketplaceInformation = "";

      const vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        pazaryeri: pazaryeri,
        barkod: vm.stockBarcode,
        kod: vm.stockCode,
      };

      soap.createClient(url, function(err, client) {
        vs.loading({
          container: "#loading-stock-price-update",
          type: "radius",
        });

        client.stokPazaryeriDetay(args, function(err, result) {
          if (result.stokPazaryeriDetayResult == "-1") {
            Store.dispatch("logout");
          }

          try {
            const parsedResponse = JSON.parse(result.stokPazaryeriDetayResult);
            const response = Array.isArray(parsedResponse)
              ? parsedResponse[0] || {}
              : parsedResponse;
            const detay = response.data || {};
            vs.loading.close("#loading-stock-price-update > .con-vs-loading");

            if (response.error == "No") {
              if (!pazaryeri) {
                vm.setMarketplaces(detay.pazaryeri);
                if (vm.marketplaces.length > 0) {
                  vm.activeMarketplace = vm.marketplaces[0].name;
                }
              }

              vm.stockDetailSalePrice = String(detay.SATIS_FIAT1).replace(",", ".");
              vm.stockDetailCurrentPrice = String(detay.PiyasaFiyati).replace(",", ".");
              vm.originalDetailSalePrice = vm.stockDetailSalePrice;
              vm.originalDetailCurrentPrice = vm.stockDetailCurrentPrice;

            } else {
              vm.stockDetailSalePrice = "";
              vm.stockDetailCurrentPrice = "";
              vm.originalDetailSalePrice = "";
              vm.originalDetailCurrentPrice = "";
              vm.marketplaceInformation = response.message || "Stok pazaryeri detayı alınamadı";
              vs.notify({
                title: "Fiyat Güncelle",
                text: vm.marketplaceInformation,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            vs.loading.close("#loading-stock-price-update > .con-vs-loading");
            vs.notify({
              title: "Fiyat Güncelle",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
    priceUpdate() {
      const vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        SatisFiyati: vm.stockDetailSalePrice,
        ListeFiyati: vm.stockDetailCurrentPrice,
        Pazaryeri: vm.activeMarketplace,
        StokKodu: vm.stockCode,
        Barkod: vm.stockBarcode,
      };

      soap.createClient(url, function(err, client) {
        vs.loading({
          container: "#button-with-loading-price-update",
          type: "radius",
        });

        client.pazaryerifiyatguncelle(args, function(err, result) {
          if (result.pazaryerifiyatguncelleResult == "-1") {
            Store.dispatch("logout");
          }

          try {
            const response = JSON.parse(result.pazaryerifiyatguncelleResult);
            vs.loading.close("#button-with-loading-price-update > .con-vs-loading");

            vs.notify({
              title: "Fiyat Güncelle",
              text: response.mesaj,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: response.response == "Ok" ? "success" : "danger",
              position: "top-center",
            });

            if (response.response == "Ok") {
              vm.pazaryeriDetay(vm.activeMarketplace);
            }
          } catch (error) {
            vs.loading.close("#button-with-loading-price-update > .con-vs-loading");
            vs.notify({
              title: "Fiyat Güncelle",
              text: error,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
    },
  },
};
</script>
